import React from 'react';
import { ImageTitle } from '../../core/ImageTitle';
import { TextboxControl } from '../../controls/TextboxControl';
import { DropdownControl } from '../../controls/DropdownControl';
import { ApiDataAccess } from '../../infrastructure/ApiDataAccess';
import { Card, Row, Column } from '../../components/Containers';
import { Alert } from '../../components/Components';

import './ProductFinderView.css'
export class ProductFinderView extends React.Component {

    constructor(props) {
        super(props);

        const queryString = window.location.search;         
        const urlParams = new URLSearchParams(queryString);
        const search = urlParams.get('search');

        this.synonyms = [];
        
        this.state = {
            complete: false,
            search: search ? search : '',
            attributes: null,
            productGroupId: null,
            valid: false
        };
    }
    

    async evaluateAsync() {
        this.setState({ attributes: null, complete: false });

        var dataAccess = new ApiDataAccess('/api/productCategorization');
        var attributes = await dataAccess.post('/', { text: this.state.search });        
        this.setState({
            attributes: attributes,
            productGroupId: attributes.productGroupId,
            complete: true
        });
        this.validate(attributes);
    }

    async onAttributeSelected(name, val) {
        var attributes = this.state.attributes;
        attributes[name] = val;
        this.setState({ attributes: attributes });
        await this.loadProductGroup(attributes);
    }

    async onCategorySelected(industryId, categoryId) {
        var attributes = this.state.attributes;
        attributes.industryId = industryId;
        attributes.categoryId = categoryId;

        this.setState({
            attributes: attributes
        })
        this.validate(attributes);
    }

    async onSynonymChange(synonyms) {        
        this.synonyms = synonyms;
    }

    async loadProductGroup(attributes) {
        this.setState({ productGroupId: null });
        var dataAccess = new ApiDataAccess('/api/productCategorization');
        var response = await dataAccess.post('/ProductGroup', attributes);        
        this.setState({ productGroupId: response.id });
        this.validate(attributes);
    }

    validate(attributes) {

        var valid = true;

        if (!attributes.consistencyId || attributes.consistencyId < 0) {
            valid = false;
        }

        if (!attributes.moistureId || attributes.moistureId < 0) {
            valid = false;
        }

        if (!attributes.aromaId || attributes.aromaId < 0) {
            valid = false;
        }

        if (!attributes.lightSensitivityId || attributes.lightSensitivityId < 0) {
            valid = false;
        }

        if (!attributes.shelfLifeTimeId || attributes.shelfLifeTimeId < 0) {
            valid = false;
        }

        if (!attributes.childResistencyId || attributes.childResistencyId < 0) {
            valid = false;
        }

        if (!attributes.aggressivenessId || attributes.aggressivenessId < 0) {
            valid = false;
        }

        if (!attributes.emissionsId || attributes.emissionsId < 0) {
            valid = false;
        }

        if (!attributes.packagingTemperatureId || attributes.packagingTemperatureId < 0) {
            valid = false;
        }

        if (!attributes.oxygenSensitivityId || attributes.oxygenSensitivityId < 0) {
            valid = false;
        }

        if (!attributes.industryId || attributes.industryId < 0) {
            valid = false;
        }

        if (!attributes.categoryId || attributes.categoryId < 0) {
            valid = false;
        }

        if (attributes.productExists) {
            valid = false;
        }

        this.setState({ valid: valid })
    }

    async onSaveClick() {

        var reviewId = this.getReviewIdFromUrl();

        var payload = this.state.attributes;
        payload.syonyms = this.synonyms;
        payload.productReviewId = reviewId

        var dataAccess = new ApiDataAccess('/api/productCategorization');
        var response = await dataAccess.post('/save', payload);   

        if (reviewId) {
            window.Router.setRoute('/products/review');
        }
        else {
            window.Router.setRoute('/');
        } 
    }

    async onDeleteClick() {
        var reviewId = this.getReviewIdFromUrl();
        window.Confirmation.show('Delete', 'Are you sure to delete this Product Request?',
            async () => {
                try {
                    var dataAccess = new ApiDataAccess('/data/productReviews');
                    await dataAccess.delete(`/${reviewId}`);
                    window.Router.setRoute('/products/review');
                }
                catch {
                    window.Router.setRoute('/products/review');
                }
            }
        );
    }

    getReviewIdFromUrl() {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const reviewId = urlParams.get('reviewId');
        return reviewId;
    }


    render() {
        return (
            <div className="view finder">
                <ImageTitle text='Product Research Lab' />

                <p>Enter a customer product which you would like to categorize:</p>
                <TextboxControl value={this.state.search} onChange={txt => { this.setState({ search: txt ? txt : '' }) }} />

                {this.getReviewIdFromUrl() && !this.state.complete &&
                    <button className='btn btn-primary' onClick={() => { this.onDeleteClick() }}>Delete</button>
                }

                <button className='btn btn-secondary pull-right' disabled={!this.state.search} onClick={async () => { await this.evaluateAsync() }}>Research</button>

                {this.state.complete && 
                    <div>
                        <Alert type='info'>Review the attributes and configurations for this product and make adjustements as needed before you save it.</Alert>

                        <div>
                            {this.state.attributes.productExists &&
                                <Alert type='warn'>A product with this name exists already. This product can not be saved.</Alert>
                            }

                            {!this.state.attributes || !this.state.attributes.success &&
                                <Alert type='info'>I was not able to categorize this product. Please review this product manually.</Alert>
                            }

                            <Card title={this.state.attributes.product} subtitle='These are the attributes to describe this product'>
                                <Row>
                                    <Column>Consistency</Column>
                                    <Column>
                                        <AttributeSelector dataSource="ProductConsistencies" value={this.state.attributes.consistencyId} onChange={(val, item) => { this.onAttributeSelected("consistencyId", val, item) }} />
                                    </Column>
                                </Row>

                                <Row>
                                    <Column>Moisture</Column>
                                    <Column>
                                        <AttributeSelector dataSource="ProductMoistures" value={this.state.attributes.moistureId} onChange={(val, item) => { this.onAttributeSelected("moistureId", val, item) }} />
                                    </Column>
                                </Row>

                                <Row>
                                    <Column>Aroma</Column>
                                    <Column>
                                        <AttributeSelector dataSource="ProductAromas" value={this.state.attributes.aromaId} onChange={(val, item) => { this.onAttributeSelected("aromaId", val, item) }} />
                                    </Column>
                                </Row>

                                <Row>
                                    <Column>Light Sensitivity</Column>
                                    <Column>
                                        <AttributeSelector dataSource="ProductLightSensitivities" value={this.state.attributes.lightSensitivityId} onChange={(val, item) => { this.onAttributeSelected("lightSensitivityId", val, item) }} />
                                    </Column>
                                </Row>

                                <Row>
                                    <Column>Shelf Life Time</Column>
                                    <Column>
                                        <AttributeSelector dataSource="ProductShelfLifeTimes" value={this.state.attributes.shelfLifeTimeId} onChange={(val, item) => { this.onAttributeSelected("shelfLifeTimeId", val, item) }} />
                                    </Column>
                                </Row>

                                <Row>
                                    <Column>Child Resistency</Column>
                                    <Column>
                                        <AttributeSelector dataSource="ProductChildResistances" value={this.state.attributes.childResistencyId} onChange={(val, item) => { this.onAttributeSelected("childResistencyId", val, item) }} />
                                    </Column>
                                </Row>

                                <Row>
                                    <Column>Aggressiveness</Column>
                                    <Column>
                                        <AttributeSelector dataSource="ProductAgressivnesses" value={this.state.attributes.aggressivenessId} onChange={(val, item) => { this.onAttributeSelected("aggressivenessId", val, item) }} />
                                    </Column>
                                </Row>

                                <Row>
                                    <Column>Emissions</Column>
                                    <Column>
                                        <AttributeSelector dataSource="ProductEmissions" value={this.state.attributes.emissionsId} onChange={(val, item) => { this.onAttributeSelected("emissionsId", val, item) }} />
                                    </Column>
                                </Row>

                                <Row>
                                    <Column>Packaging Temperature</Column>
                                    <Column>
                                        <AttributeSelector dataSource="ProductTemperatures" value={this.state.attributes.packagingTemperatureId} onChange={(val, item) => { this.onAttributeSelected("packagingTemperatureId", val, item) }} />
                                    </Column>
                                </Row>

                                <Row>
                                    <Column>OxygenSensitivity</Column>
                                    <Column>
                                        <AttributeSelector dataSource="ProductOxygenSensitivities" value={this.state.attributes.oxygenSensitivityId} onChange={(val, item) => { this.onAttributeSelected("oxygenSensitivityId", val, item) }} />
                                    </Column>
                                </Row>
                            </Card>

                            <Card title='Industry / Category' subtitle='These is the recommended industry and category for this product'>
                                {!this.state.attributes.categoryId &&
                                    <Alert type='info'>I was not able to find an appropriate industry and category.</Alert>
                                }
                                <IndustryCategorySelector industryId={this.state.attributes.industryId} categoryId={this.state.attributes.categoryId} onChange={(industryId, categoryId) => { this.onCategorySelected(industryId, categoryId) }} />
                            </Card>


                            {this.state.attributes.similarProducts && this.state.attributes.similarProducts.length > 0 &&
                                <Card title='Existing Products' subtitle='These are similar products, which exist already. Consider to merge the synonyms with these products.'>
                                    {this.state.attributes.similarProducts.map((item, idx) => {
                                        return (
                                            <Row key={`syn_${idx}`}>
                                                <Column><span className='color-blue'>{item.item2}</span></Column>
                                            </Row>
                                        )
                                    })}
                                </Card>
                            }

                            <Card title='Synonyms' subtitle='These is the synonyms for this product'>
                                <SynonymList items={this.state.attributes.synonyms} onChange={synonyms => this.onSynonymChange(synonyms)} />
                            </Card>


                            {this.state.productGroupId ?
                                <Card title='Packaging Group' subtitle='This is the packaging group for this product'>
                                    <Row>
                                        <Column>Product Group</Column>
                                        <Column><span className='color-blue'>GROUP-{this.state.productGroupId}</span></Column>
                                    </Row>

                                </Card>
                                : <Alert type='info'>I was not able to find an appropriate packaging group.</Alert>
                            }


                            {this.state.productGroupId &&
                                <Card title='Standard Products' subtitle='These are the standard products available for this product:'>
                                    <StandardPouchRegistry productGroupId={this.state.productGroupId} />
                                </Card>
                            }

                        </div>

                        {this.getReviewIdFromUrl() &&
                            <button className='btn btn-primary' onClick={() => { this.onDeleteClick() }}>Delete</button>
                        }

                        <button className='btn btn-secondary pull-right' disabled={!this.state.valid} onClick={() => {this.onSaveClick()}}>Save</button>

                    </div>
                }
            </div>

        );
    }
}

export class SynonymList extends React.Component {

    constructor(props) {
        super(props);

        this.items = this.props.items;

        this.state = {
            items: this.items
        }
    }

    onChange(idx, value) {        
        this.items[idx] = value;          
        this.notifySubscribers();
    }

    onDeleteClick(idx, item) {        
        this.items.splice(idx, 1);        
        this.setState({ items: this.items });
        this.notifySubscribers();
    }

    onAddClick() {
        this.items.push('');
        this.setState({ items: this.items });
        this.notifySubscribers();
    }

    notifySubscribers() {
        if (this.props.onChange) {
            const cleanArray = this.items.filter(item => item.trim() !== "");
            this.props.onChange(cleanArray);
        }        
    }

    render() {
        return (
            <div className='synonymList'>
                {this.state.items &&
                    <div>
                        {this.state.items.map((item, idx) => {
                            return (
                                <Row key={`syn_${idx}`}>
                                    <TextboxControl key={`syn_txt_${item}_${idx}`} value={item} onChange={val => { this.onChange(idx, val) }} />
                                    <button className='btn btn-primary-outline' onClick={() => { this.onDeleteClick(idx, item) }}><span className='glyphicon glyphicon-trash'></span></button>
                                </Row>
                            )
                        })}
                    </div>
                }
                <button className='btn btn-secondary-outline pull-right' onClick={() => { this.onAddClick() }}><span className='glyphicon glyphicon-plus'></span></button>
            </div>
        )
    }
}

export class StandardPouchRegistry extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            items: null
        }
    }

    componentDidMount() {
        this.readData(this.props.productGroupId);
    }

    async readData(productGroupId) {
        var dataAccess = new ApiDataAccess('/api/productCategorization');
        var response = await dataAccess.get(`/productGroup/${productGroupId}/standardProducts`);
        this.setState({ items: response });
    }

    render() {
        return (
            <div>
                {this.state.items && this.state.items.length > 0 ?
                    <div>
                        <Row>
                            <Column>Converting Method</Column>
                            <Column>Count</Column>
                        </Row>
                        
                        {this.state.items.map((item, idx) => {
                            return (
                                <Row key={`sprow_${idx}`}>
                                    <Column>{item.item1}</Column>
                                    <Column><span className='color-blue'>{item.item2}</span></Column>
                                </Row>
                            )
                        })}
                    </div>
                    : <Alert type='info'>No Standard Pouches are available for this product.</Alert>
                }
            </div>
        )
    }
}


export class IndustryCategorySelector extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedIndustryId: this.props.industryId,
            selectedCategoryId: this.props.categoryId,
            industries: null,
            categories: null,
            availableCategories: null
        }
    }

    componentDidMount() {
        this.getIndustryDataSourceItems();
        this.getCategoriesDataSourceItems();
    }

    async getIndustryDataSourceItems() {
        var dataAccess = new ApiDataAccess('/data/datasources');
        var data = await dataAccess.get(`/Industries`);
        this.setState({ industries: data });
    }

    async getCategoriesDataSourceItems() {
        var dataAccess = new ApiDataAccess('/data/datasources');
        var data = await dataAccess.get(`/IndustryCategories`);
        this.setState({ categories: data });

        if (this.props.industryId) {
            var availableCategories = data.filter(e => e.industryId == this.props.industryId)
            this.setState({ availableCategories: availableCategories });
        }

    }

    onSelectIndustry(val) {
        this.setState({ availableCategories: null });
        var availableCategories = this.state.categories.filter(e => e.industryId == val)
        this.setState({
            availableCategories: availableCategories,
            selectedIndustryId: val
        });        

        if (this.props.onChange) {
            this.props.onChange(val, null);
        }

    }

    onSelectCategory(val) {

        this.setState({
            selectedCategoryId: val
        });

        if (this.props.onChange) {
            this.props.onChange(this.state.selectedIndustryId, val);
        }

    }


    render() {

        return (
            <div>

                {this.state.industries &&
                    <div>
                        <label>Industry</label>
                        <DropdownControl valueMemberName='id' displayMemberName='name' items={this.state.industries} value={this.state.selectedIndustryId} onChange={(val, item) => { this.onSelectIndustry(val, item) }} />
                    </div>
                }

                {this.state.availableCategories &&
                    <div>
                        <label>Category</label>
                        <DropdownControl valueMemberName='id' displayMemberName='name' items={this.state.availableCategories} value={this.state.selectedCategoryId} onChange={(val, item) => { this.onSelectCategory(val, item) }} />
                    </div >
                }
            </div>
        )
    }
}

export class AttributeSelector extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            items: null
        }
    }

    componentDidMount() {
        this.getDataSourceItems(this.props.dataSource);
    }
   
    async getDataSourceItems(name) {
        var dataAccess = new ApiDataAccess('/data/datasources');
        var data = await dataAccess.get(`/${name}`);
        this.setState({ items: data });
    }

    onChange(val, item) {
        if (this.props.onChange) {
            this.props.onChange(val, item);
        }
    }

    render() {
        return (
            this.state.items &&
            <DropdownControl valueMemberName='id' displayMemberName='name' items={this.state.items} value={this.props.value} onChange={(val, item) => { this.onChange(val, item) } } />
        )
    }

}
